import { Flex, Text } from '@backstage/ui';

import { extractLastNameComponent } from '@spotify/confidence-core-react';
import { AttachmentFragment } from '@spotify/confidence-graphql';

import { PreviewShell } from './components';

interface DefaultResourcePreviewProps {
  artifact: AttachmentFragment;
  resourceName: string;
  label: string;
}

export const DefaultResourcePreview = ({
  artifact,
  resourceName,
  label,
}: DefaultResourcePreviewProps) => (
  <PreviewShell resourceName={resourceName} label={label}>
    <Flex direction="column" gap="1">
      <Text variant="body-medium" weight="bold">
        {artifact.displayName || extractLastNameComponent(artifact.uri)}
      </Text>
      <Text variant="body-small" color="secondary">
        {label}
      </Text>
    </Flex>
  </PreviewShell>
);
